import React from "react";
import style from "./ProductDivisionChips.module.scss";

const normalize = (item) => ({
  key: item.key ?? item.productDivisionId,
  value: item.value ?? item.productDivisionDesc,
});

export const ProductDivisionChips = ({ productDivision = [], selectedKeys, onToggle }) => {
  if (!productDivision.length) return null;

  return (
    <div className={style.chipRow}>
      {productDivision.map((raw) => {
        const { key, value } = normalize(raw);
        const isSelected = selectedKeys.includes(key);
        return (
          <button
            key={key}
            type="button"
            className={`${style.chip} ${isSelected ? style.chipSelected : ""}`}
            onClick={() => onToggle(key)}
            aria-pressed={isSelected}
          >
            {value}
          </button>
        );
      })}
    </div>
  );
};
